import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { changeJourneyParam } from '@store/yourJourney/actions';

import { DiningV2 } from './DiningV2';

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ changeJourneyParam }, dispatch);

export const DiningV2Connected = connect(null, mapDispatchToProps)(DiningV2);
